var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"EN"}},[_c('home-header',{attrs:{"navName":_vm.navName}}),_vm._v(" "),_c('div',{attrs:{"id":"bodyer"}},[_vm._v("\n\t\tEN\n\t")]),_vm._v(" "),_c('home-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5856fac1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/EN.vue
// module id = null
// module chunks = 